import { render } from "./TopMenu.vue?vue&type=template&id=94f50640"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__